
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"66","height":"66","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"33","cy":"33","r":"32","stroke":"#241F21","stroke-width":"2","stroke-linecap":"square"}}),_c('path',{attrs:{"d":"M43 28.25H23V41h20V28.25zM29.429 27.542V24h7.142v3.542M26.214 40.879V27.8M39.558 40.908L39.5 28","stroke":"#241F21","stroke-width":"2"}})])
          )
        }
      }
    